import { render, staticRenderFns } from "./Home.vue?vue&type=template&id=42c11f40&scoped=true&%3Akey=%24route.path&"
import script from "./Home.vue?vue&type=script&lang=js&"
export * from "./Home.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42c11f40",
  null
  
)

export default component.exports